import { Group } from 'types';
import { Column } from 'ffsdk';

export const columns: Column<Group>[] = [
  {
    content: 'Nosaukums',
    key: 'name',
  },
];
